<template>
<div>
  <!-- 顶部查询列表 -->
  <div class="main_container">
    <div class="fuji" @click="show3 = !show3">
      <p style="margin-top:0px" class="goodslist1">
        <span style="margin-left:37px;">搜索/查询</span>
        <span class="goods_red"/>
      </p>
      <div style="position: absolute;right:-10px;top:-10px" class="sanjiao"></div>
    </div>
    <el-collapse-transition>
      <div v-show="show3">
        <div class="find">
          <el-form :inline="true" style="width:100%;display:flex;height: 55px;margin-left:-10px" :model="formInline" class="demo-form-inline findform">
            <el-form-item style="display:flex;width:100%;" label="品牌选择：" class="demo-item">
              <el-select v-model="brandId" filterable class="demo-select" placeholder="请选择">
                <el-option
                  :label="item.Name"
                  :value="item.Id"
                  v-for="(item,index) in pinpaiptions"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item style="display:flex;;width:100%" label="商品分类：" class="demo-item">
              <!-- <el-select
                v-model="shopTypeId"
                class="demo-select"
                placeholder="请选择一级分类"
                @change="cookienext()"
              >
                <el-option
                  :label="item.Name"
                  :value="item.Id"
                  v-for="(item,index) in pinleiptions"
                  :key="index"
                ></el-option>
              </el-select>
              <el-select v-model="shopTypeId2" placeholder="请选择二级分类">
                <el-option
                  :label="item.Name"
                  :value="item.Id"
                  v-for="(item,index) in pinleinextptions"
                  :key="index"
                ></el-option>
              </el-select> -->
                <el-cascader
                style="width:100%;"
                placeholder="请选择"
                :options="options1"
                filterable
                change-on-select
                @change="handleChange1"
              ></el-cascader>
            </el-form-item>
              <el-form-item style="display:flex;width:100%" label="销售类型：" >
                <el-select v-model="showtype" class="demo-select" placeholder="请选择销售类型">
                  <el-option
                    :label="item.Name"
                    :value="item.Id"
                    v-for="(item,index) in moretype"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
            
          </el-form>
          <el-form style="width:100%;display:flex;height:55px;margin-left:-10px" :inline="true" :model="formInline" class="demo-form-inline2 findform">
              <el-form-item style="display:flex;width:100%" label="商品类型：" class="demo-item">
                <el-select v-model="  CommodityId" class="demo-select" placeholder="请选择商品类型">
                  <el-option
                    :label="item.Name"
                    :value="item.Id"
                    v-for="(item,index) in   Commoditytypes"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
            <el-form-item style="display:flex;width:100%" label="所属城市：">
              <el-cascader
                style="width:100%;"
                placeholder="请选择城市"
                :options="options"
                filterable
                change-on-select
                @change="handleChange"
              ></el-cascader>
              <!-- <el-select
          v-model="provinceId"
          class="demo-select"
          placeholder="请选择省"
          @change="getCity()"
        >
          <el-option
            :label="item.Name"
            :value="item.Id"
            v-for="(item,index) in tbdprovince"
            :key="index"
          ></el-option>
        </el-select>
        <el-select v-model="cityId" class="demo-select" placeholder="请选择市">
          <el-option
            :label="item.Name"
            :value="item.Id"
            v-for="(item,index) in tbdcity"
            :key="index"
          ></el-option>
              </el-select>-->
            </el-form-item>
            <el-form-item style="display:flex;width:100%" label="商品名称：">
              <el-input  v-model="name" placeholder="请输入查询商品名称"></el-input>
            </el-form-item>
          
          </el-form>
          <div style="margin-bottom:10px;float:right;margin-right:10px">
              
          <el-button @click="Search ()" class="Establish">查询</el-button>
          <el-button @click="reset ()" class="Reset">重置</el-button>
        
          </div>
        </div>
      </div>
    </el-collapse-transition>
  </div>
  <div :class="show3?'banner_table':'banner_table1'">
    <p class="goodslist1">
      <span style="margin-left:15px;">商品管理</span>
      <span class="goods_red"></span>
    </p>
    <div class="noshop" v-show="shopshow">请搜索添加商品</div>
    <div v-show="tableshow">
      <el-table :data="tableData6" border  style="width: 100%; margin-top: 20px;height:auto">
        <el-table-column prop="id" align="center" label="选择" width="100">
          <template scope="scope">
            <el-checkbox @change="sure(scope)" v-model="scope.row.Id"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column prop="name" align="center" label="主图/商品名称">
          <template scope="scope">
            <img
              style="width:50px;height:50px;float:left;margin-left:10px;"
              :data-img="scope.row.FImgs"
              @click="$imgPreview"
              :src="scope.row.FImgs"
            />
            <span
              style="display:inline-block;float:left;margin:10px 0 0 5px;"
            >{{scope.row.Title}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="GoodModelCode" align="center" label="商品编码">
          <template scope="scope">
                <span
                  :title="scope.row.GoodModelCode"
                  style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                >{{scope.row.GoodModelCode}}</span>
              </template>
        </el-table-column>
        <el-table-column prop="amount2" align="center" label="所属城市">
          <template scope="scope">
                <span
                  :title="scope.row.ProvinceName+'-'+scope.row.CityName"
                  style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                >{{scope.row.ProvinceName}}-{{scope.row.CityName}}</span>
              </template>
        </el-table-column>
        <el-table-column prop="TzrPrice" align="center" label="销售价格（元）">
            <template scope="scope">
                <span
                  :title="'￥'+scope.row.TzrPrice"
                  style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                >￥{{scope.row.TzrPrice}}</span>
              </template>
        </el-table-column>
      </el-table>
      <div class="allchecked">
        <span style="margin-top:10px;margin-left:20px;" @click="allsure()">
          <el-checkbox v-model="checked">
            全选 (
            <span>{{jLength}}</span>
            / {{tableData6.length}} )
          </el-checkbox>
        </span>
        <el-button @click="addgoods()" class="addgoods">添加</el-button>
      </div>
    </div>
    <!-- 搜索/重置弹框 -->
    <el-dialog :title="Searchorreset ? '重置提示' : '错误提示' " :visible.sync="dialogVisible"
      style="margin-top:150px;" width="30%">
      <span>{{Searchorreset?"是否重置所有的搜索项":"请选择搜索条件查询"}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" class="findEr" @click="Whether()">{{Searchorreset?"是":"确定"}}</el-button>
        <el-button type="primary" v-show="Searchorreset" class="findEr1" @click="dialogVisible = false">否</el-button>
      </span>
    </el-dialog>
    <!-- 添加弹框 -->
    <el-dialog :title="isAdd ? '添加成功提示' : '错误提示' " :visible.sync="dialogVisibleadd" width="30%"
      style="margin-top:150px;">
      <span>{{isAdd?"添加成功":"添加内容为空"}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" class="findEr" @click="dialogVisibleadd = false">{{isAdd?"确定":"返回"}}</el-button>
      </span>
    </el-dialog>
  </div>
</div>
</template>
<script>
import { getkind, BargainGoods, InsertBargainGoods } from "../../api/api";
export default {
  data() {
    return {
      show3: false,
      optionsindex: 0,
      options: [
        {
          value: 0,
          label: "全部"
        }
      ],
      optionsindex1: 0,
      options1: [
        {
          value: 0,
          label: "全部"
        }
      ],
      hash: [],
      paramList: [],
      dialogVisibleadd: false,
      isAdd: false,
      isChecked: false,
      name: "",
      pushId: [],
      CommodityId: 0,
      shopTypeId2: 0,
      brandId: 0,
      showtype: 0,
      shopTypeId: 0,
      provinceId: 0,
      cityId: 0,
      pinleinextptions: [
        {
          Id: 0,
          Name: "全部"
        }
      ],
      pinleiptions: [],
      pinpaiptions: [],
      moretype: [],
      tbdprovince: [],
      tbdcity: [
        {
          Id: 0,
          Name: "全部"
        }
      ],
      Commoditytypes: [
        {
          Id: 0,
          Name: "全部"
        },
        {
          Id: 1,
          Name: "单品"
        }
      ],
      Searchorreset: false,
      dialogVisible: false,
      checked: false,
      tableData6: [],
      shopshow: true,
      j: "",
      jLength: 0,
      tableshow: false,
      formInline: {
        user: "",
        region: ""
      }
    };
  },
  methods: {
    handleChange1(val){
  this.shopTypeId = val[0];
      if (val.length == 1) {
        for (var i = 0; i < this.options1.length; i++) {
          if (this.options1[i].value == val[0]) {
            this.optionsindex1 = i;
            this.getpinleinext();
            this.$forceUpdate();
          }
        }

        this.shopTypeId2 = 0;
      } else {
        this.shopTypeId = val[0];
        this.shopTypeId2 = val[1];
      }
    },
    handleChange(val) {
      this.provinceId = val[0];
      if (val.length == 1) {
        for (var i = 0; i < this.options.length; i++) {
          if (this.options[i].value == val[0]) {
            this.optionsindex = i;
            this.getcity();
            this.$forceUpdate();
          }
        }

        this.cityId = 0;
      } else {
        this.provinceId = val[0];
        this.cityId = val[1];
      }
    },
    //添加
    addgoods() {
      if (this.paramList.length == 0) {
        this.dialogVisibleadd = true;
        this.isAdd = false;
      } else {
        var obj = {
          paramList: this.paramList,
          operId: localStorage.Id
        };
        InsertBargainGoods(obj).then(data => {
          console.log("data", data);
          if (data.ResultCode == 1) {
            this.dialogVisibleadd = true;
            this.isAdd = true;
            this.checked = false;
            this.paramList = [];
            this.jLength = 0;
            console.log();
            this.findBargainingGoods();
          }
        });
      }
    },
    //去除重复对象
    deteleObject(obj) {
      var uniques = [];
      var stringify = {};
      for (var i = 0; i < obj.length; i++) {
        var keys = Object.keys(obj[i]);
        keys.sort(function(a, b) {
          return Number(a) - Number(b);
        });
        var str = "";
        for (var j = 0; j < keys.length; j++) {
          str += JSON.stringify(keys[j]);
          str += JSON.stringify(obj[i][keys[j]]);
        }
        if (!stringify.hasOwnProperty(str)) {
          uniques.push(obj[i]);
          stringify[str] = true;
        }
      }
      uniques = uniques;
      console.log(1);
      console.log("uniques", uniques);
      return uniques;
    },
    //查看二级分类
    cookienext() {
      this.getpinleinext();
      this.shopTypeId2 = 0;
      if (this.shopTypeId == 0) {
        this.pinleinextptions = [
          {
            Id: 0,
            Name: "全部"
          }
        ];
      }
    },
    //市
    getCity() {
      if (this.provinceId == 0) {
        this.cityId = 0;
        this.tbdcity = [
          {
            Id: 0,
            Name: "全部"
          }
        ];
      } else {
        this.getcity();
        this.cityId = 0;
      }
    },
    onSubmit() {
      console.log("submit!");
    },
    // 全选
    allsure() {
      if (this.checked) {
        this.tableData6.filter((item, index) => {
          item.Id = false;
        });
        this.paramList = [];
        this.jLength = 0;
      } else {
        this.paramList = [];
        this.tableData6.filter((item, index) => {
          item.Id = true;
          var obj = {
            id: item.GoodsId,
            name: item.BargainType
          };
          this.jLength = this.tableData6.length;
          this.paramList.push(obj);
          console.log(1123123, this.tableData6);
        });
      }
      console.log("12312312312", this.paramList);
    },
    sure(i) {
      console.log(i.row.GoodsId);
      this.i = -1;
      var obj = {
        id: i.row.GoodsId,
        name: i.row.BargainType
      };

      for (var k = 0; k < this.pushId.length; k++) {
        if (this.pushId[k] == i.row.GoodsId) {
          if (k >= 0) {
            this.i = k;
          }
        }
      }
      if (this.i >= 0) {
        this.pushId.splice(this.i, 1);
        this.paramList.splice(this.i, 1);
        this.jLength = this.paramList.length;
        if (this.jLength == this.tableData6.length) {
          this.checked = true;
        } else {
          this.checked = false;
        }
      } else {
        this.pushId.push(i.row.GoodsId);
        this.paramList.push(obj);
        this.jLength = this.paramList.length;
        if (this.jLength == this.tableData6.length) {
          this.checked = true;
        } else {
          this.checked = false;
        }
      }

      console.log(this.pushId);
      console.log(" this.paramList", this.paramList);
    },
    // 左侧已配置
    left_span() {
      this.span1_show = true;
      this.span2_show = false;
      this.Configured = true;
      this.notconfigured = false;
    },
    // 右侧未配置
    right_span() {
      this.span1_show = false;
      this.span2_show = true;
      this.Configured = false;
      this.notconfigured = true;
    },
    // 点击配置
    goconfigure() {
      this.showbanner = false;
      this.goconfigureshow = true;
    },
    //点击查询、
    Search() {
      if (
        this.CommodityId == 0 &&
        this.shopTypeId2 == 0 &&
        this.brandId == 0 &&
        this.showtype == 0 &&
        this.shopTypeId == 0 &&
        this.provinceId == 0 &&
        this.cityId == 0 &&
        this.name == ""
      ) {
        this.Searchorreset = false;
        // this.dialogVisible = true;
         this.$swal({
          type:"warning",
          text:"请选择搜索条件查询"
        })
        this.tableData6 = [];
      } else {
        this.shopshow = false;
        this.tableshow = true;
        this.findBargainingGoods();
      }
      this.jLength = 0;
      this.pushId = [];
      this.paramList = [];
    },
    //点击重置
    reset() {
      this.Searchorreset = true;
      // this.dialogVisible = true;
          this.$swal({
       type:'warning',
    text: '是否重置所有的搜索项?',
    showCancelButton:true,
      cancelButtonText: '取消',
    confirmButtonText: '确定',
  
  }).then((res) => {
 
  if(res.value){
    this.Whether()
  }
    
  })
    },
    //点击是
    Whether() {
      if (this.Searchorreset) {
        this.jLength = 0;
        this.pushId = [];
        this.paramList = [];
        this.CommodityId = 0;
        this.shopTypeId2 = 0;
        this.brandId = 0;
        this.showtype = 0;
        this.shopTypeId = 0;
        this.provinceId = 0;
        this.cityId = 0;
        this.name = "";
        this.dialogVisible = false;
        this.tableData6 = [];
        this.checked = false;
      } else {
        this.dialogVisible = false;
      }
    },
    //下拉品牌
    getpinpai() {
      let that = this;
      var loginParams = {
        tableName: "tbdbrand",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams).then(data => {
        data = data.ResultObj;
        var obj = {
          Id: 0,
          Name: "全部"
        };
        data.unshift(obj);
        that.pinpaiptions = data;
      });
    },
    //商品分类
    // getpinlei() {
    //   let that = this;
    //   var loginParams = {
    //     tableName: " tBDGoodsType",
    //     keyWord: "",
    //     parentId: ""
    //   };
    //   getkind(loginParams).then(data => {
    //       data = data.ResultObj;
    //       var obj = {
    //         Id: 0,
    //         Name: "全部"
    //       };
    //       data.unshift(obj);
    //       that.pinleiptions = data;
    //     });
    // },
    // //商品分类二级
    // getpinleinext() {
    //   let that = this;
    //   var loginParams = {
    //     tableName: " tbdgoodsbrandtype",
    //     keyWord: "",
    //     parentId: this.shopTypeId
    //   };
    //   getkind(loginParams).then(data => {
    //       data = data.ResultObj;
    //       var obj = {
    //         Id: 0,
    //         Name: "全部"
    //       };
    //       data.unshift(obj);
    //       that.pinleinextptions = data;
    //     });
    // },
    getpinlei() {
      let that = this;
      var loginParams = {
        tableName: "tBDGoodsType",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams).then(data => {
        var obj = {};
        data.ResultObj.map(item => {
          obj = item;
          obj["value"] = item["Id"];
          obj["label"] = item["Name"];
          obj["children"] = [];
          this.options1.push(obj);
        });
        data = data.ResultObj;
        var obj = {
          Id: 0,
          Name: "全部"
        };
        data.unshift(obj);
        that.pinleiptions = data;
      });
    },
    getpinleinext() {
      let that = this;
      var loginParams = {
        tableName: "tbdgoodsbrandtype",
        keyWord: "",
        parentId: this.shopTypeId
      };
      getkind(loginParams).then(data => {
        that.pinleinextptions = [];
        var obj1 = {
          value: 0,
          label: "全部"
        };
        var obj = {};
        data.ResultObj.map(item => {
          obj = item;
          obj["value"] = item["Id"];
          obj["label"] = item["Name"];
          this.pinleinextptions.push(obj);
        });
        this.pinleinextptions.unshift(obj1);
        that.options1[that.optionsindex1].children = that.pinleinextptions;
        this.$forceUpdate();
      });
    },
    //销售类型
    gettype() {
      let that = this;
      var loginParams = {
        tableName: "tbdgoodsactive",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams).then(data => {
        data = data.ResultObj;
        console.log(data);
        var obj = {
          Id: 0,
          Name: "全部"
        };
        data.unshift(obj);
        that.moretype = data;
      });
    },
    //查找省
    //查找省
    getprovince() {
      let that = this;
      var loginParams = {
        tableName: "tbdprovince",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams).then(data => {
        var obj = {};
        data.ResultObj.map(item => {
          obj = item;
          obj["value"] = item["Id"];
          obj["label"] = item["Name"];
          obj["children"] = [];
          this.options.push(obj);
        });
        data = data.ResultObj;
        var obj = {
          Id: 0,
          Name: "全部"
        };
        data.unshift(obj);
        that.tbdprovince = data;
      });
    },
    // 查找市
    getcity() {
      let that = this;
      var loginParams = {
        tableName: "tbdcity",
        keyWord: "",
        parentId: this.provinceId
      };
      getkind(loginParams).then(data => {
        that.tbdcity = [];
        var obj1 = {
          value: 0,
          label: "全部"
        };
        var obj = {};
        data.ResultObj.map(item => {
          obj = item;
          obj["value"] = item["Id"];
          obj["label"] = item["Name"];
          this.tbdcity.push(obj);
        });
        this.tbdcity.unshift(obj1);
        that.options[that.optionsindex].children = that.tbdcity;
        this.$forceUpdate();
      });
    },
    //查询砍价商品配置列表
    findBargainingGoods() {
      var loginParams = {
        brandId: this.brandId,
        goodsType: this.shopTypeId,
        goodsTypeTwo: this.shopTypeId2,
        goodsActiveId: this.showtype,
        bargainType: this.CommodityId,
        province: this.provinceId,
        city: this.cityId,
        key: this.name,
        pageIndex: 1,
        pageSize: 100000,
        type: 0,
        userId: localStorage.Id
      };
      BargainGoods(loginParams).then(data => {
        if (data.ResultCode == 1) {
          this.tableData6 = data.ResultObj;
        } else {
          this.tableData6 = [];
        }

        console.log(this.tableData6);
        this.tableData6.filter((item, index) => {
          item.isChecked = false;
        });
      });
    }
  },
  mounted() {
    //商品分类
    this.getpinlei();
    //下拉品牌
    this.getpinpai();
    this.gettype();
    //省
    this.getprovince();
  }
};
</script>
<style scoped>
.find {
  /* float: left; */
  margin-left: 33px;
}
.nowfind {
  /* width: 260px;
  height: 141px;
  float: left; */
  margin-left: 33px;
}
.demo-form-inline {
  width: 1350px;
  margin-top: 10px;
}
.demo-form-inline2 {
  width: 1350px;
}
.demo-select {
  width: 180px;
}
.demo-item {
}
.findgoods {
  width: 300px;
}
.Establish {
  background: #F56C6C;
  color: #fff;
  
}
.Reset {
 
  border: 1px solid #F56C6C;
  color: #F56C6C;
}
.banner_table {
  padding: 0 20px;
  background-color: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(14, 5, 10, 0.1);
  margin-top: 10px;
  top: 150px;
  min-height: 540px;
  width: 100%;
  float: left;
  /* overflow: hidden;
   */
}
.banner_table1 {
  padding: 0 20px;
  margin-top: -4px;
  background-color: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(14, 5, 10, 0.1);
  top: 150px;
  min-height: 220px;
  width: 100%;
  float: left;
  /* overflow: hidden;
   */
}
.noshop {
  width: 100%;
  height: 400px;
  text-align: center;
  line-height: 400px;
  font-size: 25px;
  color: #999;
}
.allchecked {
  padding-top: 15px;
  width: 100%;
  height: 35px;
  background: rgba(187, 187, 187, 0.47);
}
.addgoods {
  color: #fff;
  background: #F56C6C;
  float: right;
  height: 30px;
  line-height: 7px;
  margin-right: 2%;
  margin-top: -5px;
}
.findEr {
  border: 1px solid #F56C6C;
  background: #F56C6C;
  color: #fff;
}
.findEr1 {
  border: 1px solid #F56C6C;
  background: #fff;
  color: #F56C6C;
}
</style>


// WEBPACK FOOTER //
// markegoods.vue?f232d520